"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ListView;
    }
});
let ListView = class ListView {
    static async get(..._args) {
        return null;
    }
    static async insert(..._args) {
        return null;
    }
    static async update(..._args) {
        return null;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
